// This file is autogenerated by generate-ast.ts. DO NOT EDIT THIS FILE DIRECTLY.
import { Token } from "./tokenizer";
import { PyComplexNumber } from "./types";

export type FunctionParam = Token & {
  isStarred: boolean;
  isDoubleStarred?: boolean;
  trailingComma?: boolean;
  default?: ExprNS.Expr;
};
export type AssignTarget = ExprNS.Variable | ExprNS.Subscript;
export namespace ExprNS {
  export interface Visitor<T> {
    visitBigIntLiteralExpr(expr: BigIntLiteral): T;
    visitBinaryExpr(expr: Binary): T;
    visitCompareExpr(expr: Compare): T;
    visitBoolOpExpr(expr: BoolOp): T;
    visitGroupingExpr(expr: Grouping): T;
    visitLiteralExpr(expr: Literal): T;
    visitUnaryExpr(expr: Unary): T;
    visitTernaryExpr(expr: Ternary): T;
    visitLambdaExpr(expr: Lambda): T;
    visitMultiLambdaExpr(expr: MultiLambda): T;
    visitVariableExpr(expr: Variable): T;
    visitCallExpr(expr: Call): T;
    visitListExpr(expr: List): T;
    visitSubscriptExpr(expr: Subscript): T;
    visitStarredExpr(expr: Starred): T;
    visitAttributeExpr(expr: Attribute): T;
    visitCompareChainExpr(expr: CompareChain): T;
    visitTupleExpr(expr: Tuple): T;
    visitDictExpr(expr: Dict): T;
    visitSetExpr(expr: Set): T;
    visitComprehensionExpr(expr: Comprehension): T;
    visitYieldExpr(expr: Yield): T;
    visitSliceExpr(expr: Slice): T;
    visitDoubleStarredExpr(expr: DoubleStarred): T;
    visitKeywordExpr(expr: Keyword): T;
    visitNoneExpr(expr: None): T;
    visitComplexExpr(expr: Complex): T;
  }
  export abstract class Expr {
    abstract readonly kind: string;
    startToken: Token;
    endToken: Token;
    protected constructor(startToken: Token, endToken: Token) {
      this.startToken = startToken;
      this.endToken = endToken;
    }
    abstract accept(visitor: Visitor<any>): any;
  }
  export class BigIntLiteral extends Expr {
    readonly kind = "BigIntLiteral";
    value: string;
    constructor(startToken: Token, endToken: Token, value: string) {
      super(startToken, endToken);
      this.value = value;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitBigIntLiteralExpr(this);
    }
  }
  export class Binary extends Expr {
    readonly kind = "Binary";
    left: Expr;
    operator: Token;
    right: Expr;
    constructor(startToken: Token, endToken: Token, left: Expr, operator: Token, right: Expr) {
      super(startToken, endToken);
      this.left = left;
      this.operator = operator;
      this.right = right;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitBinaryExpr(this);
    }
  }
  export class Compare extends Expr {
    readonly kind = "Compare";
    left: Expr;
    operator: Token;
    right: Expr;
    constructor(startToken: Token, endToken: Token, left: Expr, operator: Token, right: Expr) {
      super(startToken, endToken);
      this.left = left;
      this.operator = operator;
      this.right = right;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitCompareExpr(this);
    }
  }
  export class BoolOp extends Expr {
    readonly kind = "BoolOp";
    left: Expr;
    operator: Token;
    right: Expr;
    constructor(startToken: Token, endToken: Token, left: Expr, operator: Token, right: Expr) {
      super(startToken, endToken);
      this.left = left;
      this.operator = operator;
      this.right = right;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitBoolOpExpr(this);
    }
  }
  export class Grouping extends Expr {
    readonly kind = "Grouping";
    expression: Expr;
    constructor(startToken: Token, endToken: Token, expression: Expr) {
      super(startToken, endToken);
      this.expression = expression;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitGroupingExpr(this);
    }
  }
  export class Literal extends Expr {
    readonly kind = "Literal";
    value: true | false | number | string;
    constructor(startToken: Token, endToken: Token, value: true | false | number | string) {
      super(startToken, endToken);
      this.value = value;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitLiteralExpr(this);
    }
  }
  export class Unary extends Expr {
    readonly kind = "Unary";
    operator: Token;
    right: Expr;
    constructor(startToken: Token, endToken: Token, operator: Token, right: Expr) {
      super(startToken, endToken);
      this.operator = operator;
      this.right = right;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitUnaryExpr(this);
    }
  }
  export class Ternary extends Expr {
    readonly kind = "Ternary";
    predicate: Expr;
    consequent: Expr;
    alternative: Expr;
    constructor(
      startToken: Token,
      endToken: Token,
      predicate: Expr,
      consequent: Expr,
      alternative: Expr,
    ) {
      super(startToken, endToken);
      this.predicate = predicate;
      this.consequent = consequent;
      this.alternative = alternative;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitTernaryExpr(this);
    }
  }
  export class Lambda extends Expr {
    readonly kind = "Lambda";
    parameters: FunctionParam[];
    body: Expr;
    constructor(startToken: Token, endToken: Token, parameters: FunctionParam[], body: Expr) {
      super(startToken, endToken);
      this.parameters = parameters;
      this.body = body;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitLambdaExpr(this);
    }
  }
  export class MultiLambda extends Expr {
    readonly kind = "MultiLambda";
    parameters: FunctionParam[];
    body: StmtNS.Stmt[];
    varDecls: Token[];
    constructor(
      startToken: Token,
      endToken: Token,
      parameters: FunctionParam[],
      body: StmtNS.Stmt[],
      varDecls: Token[],
    ) {
      super(startToken, endToken);
      this.parameters = parameters;
      this.body = body;
      this.varDecls = varDecls;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitMultiLambdaExpr(this);
    }
  }
  export class Variable extends Expr {
    readonly kind = "Variable";
    name: Token;
    constructor(startToken: Token, endToken: Token, name: Token) {
      super(startToken, endToken);
      this.name = name;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitVariableExpr(this);
    }
  }
  export class Call extends Expr {
    readonly kind = "Call";
    callee: Expr;
    args: Expr[];
    constructor(startToken: Token, endToken: Token, callee: Expr, args: Expr[]) {
      super(startToken, endToken);
      this.callee = callee;
      this.args = args;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitCallExpr(this);
    }
  }
  export class List extends Expr {
    readonly kind = "List";
    elements: Expr[];
    constructor(startToken: Token, endToken: Token, elements: Expr[]) {
      super(startToken, endToken);
      this.elements = elements;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitListExpr(this);
    }
  }
  export class Subscript extends Expr {
    readonly kind = "Subscript";
    value: Expr;
    index: Expr;
    constructor(startToken: Token, endToken: Token, value: Expr, index: Expr) {
      super(startToken, endToken);
      this.value = value;
      this.index = index;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitSubscriptExpr(this);
    }
  }
  export class Starred extends Expr {
    readonly kind = "Starred";
    value: Expr;
    constructor(startToken: Token, endToken: Token, value: Expr) {
      super(startToken, endToken);
      this.value = value;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitStarredExpr(this);
    }
  }
  export class Attribute extends Expr {
    readonly kind = "Attribute";
    value: Expr;
    name: Token;
    constructor(startToken: Token, endToken: Token, value: Expr, name: Token) {
      super(startToken, endToken);
      this.value = value;
      this.name = name;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitAttributeExpr(this);
    }
  }
  export class CompareChain extends Expr {
    readonly kind = "CompareChain";
    left: Expr;
    operators: Token[];
    comparators: Expr[];
    constructor(
      startToken: Token,
      endToken: Token,
      left: Expr,
      operators: Token[],
      comparators: Expr[],
    ) {
      super(startToken, endToken);
      this.left = left;
      this.operators = operators;
      this.comparators = comparators;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitCompareChainExpr(this);
    }
  }
  export class Tuple extends Expr {
    readonly kind = "Tuple";
    elements: Expr[];
    constructor(startToken: Token, endToken: Token, elements: Expr[]) {
      super(startToken, endToken);
      this.elements = elements;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitTupleExpr(this);
    }
  }
  export class Dict extends Expr {
    readonly kind = "Dict";
    keys: (Expr | null)[];
    values: Expr[];
    constructor(startToken: Token, endToken: Token, keys: (Expr | null)[], values: Expr[]) {
      super(startToken, endToken);
      this.keys = keys;
      this.values = values;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitDictExpr(this);
    }
  }
  export class Set extends Expr {
    readonly kind = "Set";
    elements: Expr[];
    constructor(startToken: Token, endToken: Token, elements: Expr[]) {
      super(startToken, endToken);
      this.elements = elements;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitSetExpr(this);
    }
  }
  export class Comprehension extends Expr {
    readonly kind = "Comprehension";
    variant: "list" | "set" | "dict" | "generator";
    element: Expr;
    value: Expr | null;
    generators: { target: Expr; iter: Expr; conditions: Expr[] }[];
    constructor(
      startToken: Token,
      endToken: Token,
      variant: "list" | "set" | "dict" | "generator",
      element: Expr,
      value: Expr | null,
      generators: { target: Expr; iter: Expr; conditions: Expr[] }[],
    ) {
      super(startToken, endToken);
      this.variant = variant;
      this.element = element;
      this.value = value;
      this.generators = generators;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitComprehensionExpr(this);
    }
  }
  export class Yield extends Expr {
    readonly kind = "Yield";
    value: Expr | null;
    delegate: boolean;
    constructor(startToken: Token, endToken: Token, value: Expr | null, delegate: boolean) {
      super(startToken, endToken);
      this.value = value;
      this.delegate = delegate;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitYieldExpr(this);
    }
  }
  export class Slice extends Expr {
    readonly kind = "Slice";
    lower: Expr | null;
    upper: Expr | null;
    step: Expr | null;
    constructor(
      startToken: Token,
      endToken: Token,
      lower: Expr | null,
      upper: Expr | null,
      step: Expr | null,
    ) {
      super(startToken, endToken);
      this.lower = lower;
      this.upper = upper;
      this.step = step;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitSliceExpr(this);
    }
  }
  export class DoubleStarred extends Expr {
    readonly kind = "DoubleStarred";
    value: Expr;
    constructor(startToken: Token, endToken: Token, value: Expr) {
      super(startToken, endToken);
      this.value = value;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitDoubleStarredExpr(this);
    }
  }
  export class Keyword extends Expr {
    readonly kind = "Keyword";
    name: Token;
    value: Expr;
    constructor(startToken: Token, endToken: Token, name: Token, value: Expr) {
      super(startToken, endToken);
      this.name = name;
      this.value = value;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitKeywordExpr(this);
    }
  }
  export class None extends Expr {
    readonly kind = "None";
    constructor(startToken: Token, endToken: Token) {
      super(startToken, endToken);
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitNoneExpr(this);
    }
  }
  export class Complex extends Expr {
    readonly kind = "Complex";
    value: PyComplexNumber;
    constructor(startToken: Token, endToken: Token, value: string) {
      super(startToken, endToken);
      this.value = PyComplexNumber.fromString(value);
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitComplexExpr(this);
    }
  }
}
export namespace StmtNS {
  export interface Visitor<T> {
    visitPassStmt(stmt: Pass): T;
    visitAssignStmt(stmt: Assign): T;
    visitAugAssignStmt(stmt: AugAssign): T;
    visitAttributeAssignStmt(stmt: AttributeAssign): T;
    visitForUnpackStmt(stmt: ForUnpack): T;
    visitTupleAssignStmt(stmt: TupleAssign): T;
    visitAnnAssignStmt(stmt: AnnAssign): T;
    visitBreakStmt(stmt: Break): T;
    visitContinueStmt(stmt: Continue): T;
    visitReturnStmt(stmt: Return): T;
    visitFromImportStmt(stmt: FromImport): T;
    visitGlobalStmt(stmt: Global): T;
    visitNonLocalStmt(stmt: NonLocal): T;
    visitAssertStmt(stmt: Assert): T;
    visitClassStmt(stmt: Class): T;
    visitDecoratedStmt(stmt: Decorated): T;
    visitTryStmt(stmt: Try): T;
    visitRaiseStmt(stmt: Raise): T;
    visitWithStmt(stmt: With): T;
    visitDelStmt(stmt: Del): T;
    visitImportStmt(stmt: Import): T;
    visitIfStmt(stmt: If): T;
    visitWhileStmt(stmt: While): T;
    visitForStmt(stmt: For): T;
    visitFunctionDefStmt(stmt: FunctionDef): T;
    visitSimpleExprStmt(stmt: SimpleExpr): T;
    visitFileInputStmt(stmt: FileInput): T;
  }
  export abstract class Stmt {
    abstract readonly kind: string;
    startToken: Token;
    endToken: Token;
    protected constructor(startToken: Token, endToken: Token) {
      this.startToken = startToken;
      this.endToken = endToken;
    }
    abstract accept(visitor: Visitor<any>): any;
  }
  export class Pass extends Stmt {
    readonly kind = "Pass";
    constructor(startToken: Token, endToken: Token) {
      super(startToken, endToken);
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitPassStmt(this);
    }
  }
  export class Assign extends Stmt {
    readonly kind = "Assign";
    target: AssignTarget;
    value: ExprNS.Expr;
    constructor(startToken: Token, endToken: Token, target: AssignTarget, value: ExprNS.Expr) {
      super(startToken, endToken);
      this.target = target;
      this.value = value;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitAssignStmt(this);
    }
  }
  export class AugAssign extends Stmt {
    readonly kind = "AugAssign";
    target: ExprNS.Expr;
    operator: Token;
    value: ExprNS.Expr;
    constructor(
      startToken: Token,
      endToken: Token,
      target: ExprNS.Expr,
      operator: Token,
      value: ExprNS.Expr,
    ) {
      super(startToken, endToken);
      this.target = target;
      this.operator = operator;
      this.value = value;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitAugAssignStmt(this);
    }
  }
  export class AttributeAssign extends Stmt {
    readonly kind = "AttributeAssign";
    target: ExprNS.Attribute;
    value: ExprNS.Expr;
    constructor(startToken: Token, endToken: Token, target: ExprNS.Attribute, value: ExprNS.Expr) {
      super(startToken, endToken);
      this.target = target;
      this.value = value;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitAttributeAssignStmt(this);
    }
  }
  export class ForUnpack extends Stmt {
    readonly kind = "ForUnpack";
    target: ExprNS.Tuple;
    iter: ExprNS.Expr;
    body: Stmt[];
    constructor(
      startToken: Token,
      endToken: Token,
      target: ExprNS.Tuple,
      iter: ExprNS.Expr,
      body: Stmt[],
    ) {
      super(startToken, endToken);
      this.target = target;
      this.iter = iter;
      this.body = body;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitForUnpackStmt(this);
    }
  }
  export class TupleAssign extends Stmt {
    readonly kind = "TupleAssign";
    target: ExprNS.Tuple;
    value: ExprNS.Expr;
    constructor(startToken: Token, endToken: Token, target: ExprNS.Tuple, value: ExprNS.Expr) {
      super(startToken, endToken);
      this.target = target;
      this.value = value;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitTupleAssignStmt(this);
    }
  }
  export class AnnAssign extends Stmt {
    readonly kind = "AnnAssign";
    target: ExprNS.Variable;
    value: ExprNS.Expr;
    ann: ExprNS.Expr;
    constructor(
      startToken: Token,
      endToken: Token,
      target: ExprNS.Variable,
      value: ExprNS.Expr,
      ann: ExprNS.Expr,
    ) {
      super(startToken, endToken);
      this.target = target;
      this.value = value;
      this.ann = ann;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitAnnAssignStmt(this);
    }
  }
  export class Break extends Stmt {
    readonly kind = "Break";
    constructor(startToken: Token, endToken: Token) {
      super(startToken, endToken);
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitBreakStmt(this);
    }
  }
  export class Continue extends Stmt {
    readonly kind = "Continue";
    constructor(startToken: Token, endToken: Token) {
      super(startToken, endToken);
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitContinueStmt(this);
    }
  }
  export class Return extends Stmt {
    readonly kind = "Return";
    value: ExprNS.Expr | null;
    constructor(startToken: Token, endToken: Token, value: ExprNS.Expr | null) {
      super(startToken, endToken);
      this.value = value;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitReturnStmt(this);
    }
  }
  export class FromImport extends Stmt {
    readonly kind = "FromImport";
    module: Token;
    names: { name: Token; alias: Token | null }[];
    level: number;
    constructor(
      startToken: Token,
      endToken: Token,
      module: Token,
      names: { name: Token; alias: Token | null }[],
      level: number,
    ) {
      super(startToken, endToken);
      this.module = module;
      this.names = names;
      this.level = level;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitFromImportStmt(this);
    }
  }
  export class Global extends Stmt {
    readonly kind = "Global";
    names: Token[];
    constructor(startToken: Token, endToken: Token, names: Token[]) {
      super(startToken, endToken);
      this.names = names;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitGlobalStmt(this);
    }
  }
  export class NonLocal extends Stmt {
    readonly kind = "NonLocal";
    names: Token[];
    constructor(startToken: Token, endToken: Token, names: Token[]) {
      super(startToken, endToken);
      this.names = names;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitNonLocalStmt(this);
    }
  }
  export class Assert extends Stmt {
    readonly kind = "Assert";
    value: ExprNS.Expr;
    message: ExprNS.Expr | null;
    constructor(
      startToken: Token,
      endToken: Token,
      value: ExprNS.Expr,
      message: ExprNS.Expr | null,
    ) {
      super(startToken, endToken);
      this.value = value;
      this.message = message;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitAssertStmt(this);
    }
  }
  export class Class extends Stmt {
    readonly kind = "Class";
    name: Token;
    bases: ExprNS.Expr[];
    body: Stmt[];
    constructor(
      startToken: Token,
      endToken: Token,
      name: Token,
      bases: ExprNS.Expr[],
      body: Stmt[],
    ) {
      super(startToken, endToken);
      this.name = name;
      this.bases = bases;
      this.body = body;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitClassStmt(this);
    }
  }
  export class Decorated extends Stmt {
    readonly kind = "Decorated";
    decorators: ExprNS.Expr[];
    definition: Stmt;
    constructor(startToken: Token, endToken: Token, decorators: ExprNS.Expr[], definition: Stmt) {
      super(startToken, endToken);
      this.decorators = decorators;
      this.definition = definition;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitDecoratedStmt(this);
    }
  }
  export class Try extends Stmt {
    readonly kind = "Try";
    body: Stmt[];
    handlers: { type: ExprNS.Expr | null; name: Token | null; body: Stmt[] }[];
    orElse: Stmt[] | null;
    finalBody: Stmt[] | null;
    constructor(
      startToken: Token,
      endToken: Token,
      body: Stmt[],
      handlers: { type: ExprNS.Expr | null; name: Token | null; body: Stmt[] }[],
      orElse: Stmt[] | null,
      finalBody: Stmt[] | null,
    ) {
      super(startToken, endToken);
      this.body = body;
      this.handlers = handlers;
      this.orElse = orElse;
      this.finalBody = finalBody;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitTryStmt(this);
    }
  }
  export class Raise extends Stmt {
    readonly kind = "Raise";
    value: ExprNS.Expr | null;
    cause: ExprNS.Expr | null;
    constructor(
      startToken: Token,
      endToken: Token,
      value: ExprNS.Expr | null,
      cause: ExprNS.Expr | null,
    ) {
      super(startToken, endToken);
      this.value = value;
      this.cause = cause;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitRaiseStmt(this);
    }
  }
  export class With extends Stmt {
    readonly kind = "With";
    items: { context: ExprNS.Expr; target: ExprNS.Expr | null }[];
    body: Stmt[];
    constructor(
      startToken: Token,
      endToken: Token,
      items: { context: ExprNS.Expr; target: ExprNS.Expr | null }[],
      body: Stmt[],
    ) {
      super(startToken, endToken);
      this.items = items;
      this.body = body;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitWithStmt(this);
    }
  }
  export class Del extends Stmt {
    readonly kind = "Del";
    targets: ExprNS.Expr[];
    constructor(startToken: Token, endToken: Token, targets: ExprNS.Expr[]) {
      super(startToken, endToken);
      this.targets = targets;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitDelStmt(this);
    }
  }
  export class Import extends Stmt {
    readonly kind = "Import";
    names: { name: Token; alias: Token | null }[];
    constructor(startToken: Token, endToken: Token, names: { name: Token; alias: Token | null }[]) {
      super(startToken, endToken);
      this.names = names;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitImportStmt(this);
    }
  }
  export class If extends Stmt {
    readonly kind = "If";
    condition: ExprNS.Expr;
    body: Stmt[];
    elseBlock: Stmt[] | null;
    constructor(
      startToken: Token,
      endToken: Token,
      condition: ExprNS.Expr,
      body: Stmt[],
      elseBlock: Stmt[] | null,
    ) {
      super(startToken, endToken);
      this.condition = condition;
      this.body = body;
      this.elseBlock = elseBlock;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitIfStmt(this);
    }
  }
  export class While extends Stmt {
    readonly kind = "While";
    condition: ExprNS.Expr;
    body: Stmt[];
    constructor(startToken: Token, endToken: Token, condition: ExprNS.Expr, body: Stmt[]) {
      super(startToken, endToken);
      this.condition = condition;
      this.body = body;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitWhileStmt(this);
    }
  }
  export class For extends Stmt {
    readonly kind = "For";
    target: Token;
    iter: ExprNS.Expr;
    body: Stmt[];
    constructor(
      startToken: Token,
      endToken: Token,
      target: Token,
      iter: ExprNS.Expr,
      body: Stmt[],
    ) {
      super(startToken, endToken);
      this.target = target;
      this.iter = iter;
      this.body = body;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitForStmt(this);
    }
  }
  export class FunctionDef extends Stmt {
    readonly kind = "FunctionDef";
    name: Token;
    parameters: FunctionParam[];
    body: Stmt[];
    varDecls: Token[];
    constructor(
      startToken: Token,
      endToken: Token,
      name: Token,
      parameters: FunctionParam[],
      body: Stmt[],
      varDecls: Token[],
    ) {
      super(startToken, endToken);
      this.name = name;
      this.parameters = parameters;
      this.body = body;
      this.varDecls = varDecls;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitFunctionDefStmt(this);
    }
  }
  export class SimpleExpr extends Stmt {
    readonly kind = "SimpleExpr";
    expression: ExprNS.Expr;
    constructor(startToken: Token, endToken: Token, expression: ExprNS.Expr) {
      super(startToken, endToken);
      this.expression = expression;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitSimpleExprStmt(this);
    }
  }
  export class FileInput extends Stmt {
    readonly kind = "FileInput";
    statements: Stmt[];
    varDecls: Token[];
    constructor(startToken: Token, endToken: Token, statements: Stmt[], varDecls: Token[]) {
      super(startToken, endToken);
      this.statements = statements;
      this.varDecls = varDecls;
    }
    override accept(visitor: Visitor<any>): any {
      return visitor.visitFileInputStmt(this);
    }
  }
}
